<mat-card appearance="outlined">
  <img src="../../../assets/google-play-badge.png" width="200px">
  <img src="../../../assets/apple-app-store.png" width="200px">

</mat-card>
